import React, { ReactNode } from 'react';

import '../../base.css';

type Props = {
  children?: ReactNode;
};

const ModalTitle = ({ children }: Props) => {
  return <div styleName="modal-title ">{children}</div>;
};

export default ModalTitle;
